class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('[data-search-input]');
    this.resultsContainer = this.querySelector('[data-search-results]');
    this.searchUrl = this.dataset.predictiveSearchUrl;
    this.abortController = null;
    this.debounceTimer = null;

    if (this.input) {
      this.input.addEventListener('input', this.onInput.bind(this));
    }
  }

  onInput(event) {
    var query = event.target.value.trim();
    clearTimeout(this.debounceTimer);

    if (query.length === 0) {
      this.clearResults();
      return;
    }

    this.debounceTimer = setTimeout(
      function () {
        this.fetchResults(query);
      }.bind(this),
      300
    );
  }

  clearResults() {
    if (this.resultsContainer) this.resultsContainer.innerHTML = '';
    if (this.input) this.input.setAttribute('aria-expanded', 'false');
  }

  fetchResults(query) {
    if (!this.searchUrl || !this.resultsContainer) return;

    if (this.abortController) {
      this.abortController.abort();
    }
    this.abortController = new AbortController();

    var url =
      this.searchUrl +
      '?q=' +
      encodeURIComponent(query) +
      '&section_id=predictive-search' +
      '&resources[type]=product,collection' +
      '&resources[limit]=10' +
      '&resources[options][unavailable_products]=last';

    fetch(url, { signal: this.abortController.signal })
      .then(function (response) {
        return response.text();
      })
      .then(
        function (text) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(text, 'text/html');
          var results = doc.getElementById('predictive-search-results');
          this.resultsContainer.innerHTML = results ? results.outerHTML : '';
          if (this.input) {
            this.input.setAttribute('aria-expanded', this.resultsContainer.innerHTML ? 'true' : 'false');
          }
        }.bind(this)
      )
      .catch(
        function (error) {
          if (error.name !== 'AbortError') {
            this.clearResults();
          }
        }.bind(this)
      );
  }
}

customElements.define('predictive-search', PredictiveSearch);
